<template>
  <b-modal id="modal-detail" hide-footer scrollable>
    <template #modal-header class="d-inline">
      <h5 class="titleHeader">{{ titleModal }}</h5>
      <div class="button-modal-header d-flex flex-row"></div>
    </template>
    <template>
      <div v-for="(tLabel, key) in tableLabels" :key="key">
        <b-row class="my-1">
          <b-col sm="4">
            <label for="input-default">
              {{ tLabel.itemName }}
            </label>
          </b-col>
          <b-col sm="8">
            <label v-if="tLabel.dataType === 0 || tLabel.dataType === 1">
              {{ detailData[tLabel.isItemNo] }}
            </label>
            <div v-if="tLabel.dataType === 2">
              <div
                v-for="(mstGen, mst_gen_index) in tLabel.mstGenCode"
                :key="mst_gen_index"
              >
                <label v-if="mstGen.code === detailData[tLabel.isItemNo]">
                  {{mstGen.name}}
                </label>
              </div>
            </div>
            <label v-if="tLabel.dataType === 3">
              {{ detailData[tLabel.isItemNo] | formatDate }}
            </label>
          </b-col>
        </b-row>
        <hr />
      </div>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    tableLabels: Array,
    titleModal: String,
    tableData: Array
  },
  data() {
    return {
      detailData: Object,
      indexRow: Number,
      checkConfirm: null
    }
  },
  methods: {
    showModal(index) {
      this.indexRow = index
      this.detailData = {}
      for (let key in this.tableData[index]) {
        this.detailData[key] = this.tableData[index][key]
      }
      this.$bvModal.show('modal-detail')
    }
  },
  filters: {
    formatDate(date) {
      const formatedDate = date ? moment(date).format('L LT') : ''
      return formatedDate
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
  .modal-detail {
    min-width: auto !important;
  }
}
.edit_btn {
  color: $sucess;
  .edit_icon_detail {
    font-size: 15px;
  }
  &:hover {
    text-decoration: none;
    color: $sucess;
  }
  &:focus {
    background: rgba(78, 102, 166, 0.08);
    border-radius: 40px;
  }
}
.delete_btn {
  color: $base_red;
  .delete_icon_detail {
    font-size: 15px;
  }
  &:hover {
    text-decoration: none;
    color: $base_red;
  }
  &:focus {
    background: rgba(180, 27, 62, 0.08);
    border-radius: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DetailModalComponent.vue